import { render, staticRenderFns } from "./site_settings.vue?vue&type=template&id=19c90264&scoped=true&"
import script from "./site_settings.vue?vue&type=script&lang=js&"
export * from "./site_settings.vue?vue&type=script&lang=js&"
import style0 from "./site_settings.vue?vue&type=style&index=0&id=19c90264&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19c90264",
  null
  
)

export default component.exports